import { render, staticRenderFns } from "./CompanyUserShowDetailsTab.vue?vue&type=template&id=9db86602"
import script from "./CompanyUserShowDetailsTab.vue?vue&type=script&lang=ts"
export * from "./CompanyUserShowDetailsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports